import {  createSlice, PayloadAction } from "@reduxjs/toolkit"
import { defaultEventDialogState } from "./types"
import { EventPrivateSelect } from "@pages/makeEvent/steps-components/eventMode-component/types.ts"
import { EventTypeSelection } from '@pages/makeEvent/steps-components/eventType-component/types.ts'
import { AddressLocation } from '@app/data/location/schema.ts'

export type UiRegion = {
  value?: AddressLocation
  label: string
}

export type UiAddress = {
  label: string
  value: AddressLocation
}

const eventDialogSlice = createSlice({
  name: "eventDialog",
  initialState: defaultEventDialogState(),
  reducers: {
    show: (state) => {
      state.showEvent = true
    },
    hide: () => {
      return defaultEventDialogState()
    },
    setRegion: (state, region: PayloadAction<UiRegion>) =>{
      state.region = region.payload
    },
    setAddress: (state, address: PayloadAction<UiAddress>) =>{
      state.address = address.payload
    },
    setEventMode: (state, action: PayloadAction<EventPrivateSelect>) => {
      state.eventModePrivate = action.payload
    },
    setEventType: (state, action: PayloadAction<EventTypeSelection>) => {
      state.eventType = action.payload
    },
  },
})

export const {
  show,
  hide,
  setRegion,
  setAddress,
  setEventMode,
  setEventType,} = eventDialogSlice.actions
export default eventDialogSlice.reducer
